(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-color-stock-label"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ss-stock-labels')) return;

    // Adapter for RuffRuff's embedded product JSON (observed version-212).
    // Never infer made-to-order from Shopify's continue-selling setting alone.
    // Unknown keys/conditions are deliberately unsupported until reviewed.
    const ruleKeys = new Set([
      'id', 'buttonName', 'cartMessage', 'buttonCondition', 'buttonNameIfNotMet',
      'productMessageIfNotMet', 'frequency', 'dates', 'weekdays', 'timezoneOffsetMinutes',
      'buttonConditionAfterEndsAt', 'buttonConditionBeforeStartsAt', 'buttonNameAfterEndsAt',
      'buttonNameBeforeStartsAt', 'productMessageAfterEndsAt', 'productMessageBeforeStartsAt',
      'actionsAfterEndsAtEnabled', 'actionsBeforeStartsAtEnabled', 'requireAccount',
      'customerTags', 'customerTagsCondition', 'excludedCustomerTags', 'hideDeliveryDate',
      'purchaseQuantityLimit', 'addons', 'inventoryConditionMet', 'startsAt', 'endsAt',
      'orderTag', 'productMessage'
    ]);

    class SSStockLabels extends HTMLElement {
      static reservationState(entry, now) {
        if (!entry || typeof entry.available !== 'boolean') return 'unknown';
        if (!entry.available) return 'inactive';
        const rule = entry.preOrderRule;
        if (rule === null) return 'inactive';
        if (!rule || typeof rule !== 'object' || Array.isArray(rule)) return 'unknown';
        if (Object.keys(rule).some(key => !ruleKeys.has(key))) return 'unknown';
        const buttonStates = ['visible', 'disable', 'hidden'];
        if (!['buttonCondition', 'buttonConditionAfterEndsAt', 'buttonConditionBeforeStartsAt']
              .every(key => buttonStates.includes(rule[key])) ||
            !['actionsAfterEndsAtEnabled', 'actionsBeforeStartsAtEnabled', 'hideDeliveryDate']
              .every(key => typeof rule[key] === 'boolean') ||
            !['and', 'or'].includes(rule.customerTagsCondition) ||
            typeof rule.buttonName !== 'string' ||
            !Number.isInteger(rule.timezoneOffsetMinutes) || Math.abs(rule.timezoneOffsetMinutes) > 840 ||
            !Array.isArray(rule.dates) || !rule.dates.every(day => Number.isInteger(day) && day >= 1 && day <= 31) ||
            !Array.isArray(rule.weekdays) || !rule.weekdays.every(day => Number.isInteger(day) && day >= 0 && day <= 6)) return 'unknown';
        if (rule.inventoryConditionMet === false) return 'inactive';
        if (rule.inventoryConditionMet !== true || !rule.id) return 'unknown';
        if (rule.frequency !== 'daily' || rule.requireAccount !== false ||
            !Array.isArray(rule.customerTags) || rule.customerTags.length !== 0 ||
            !Array.isArray(rule.excludedCustomerTags) || rule.excludedCustomerTags.length !== 0 ||
            rule.purchaseQuantityLimit !== null || rule.addons !== null ||
            entry.requiresSellingPlan !== false || entry.sellingPlanGroup !== null) return 'unknown';
        for (const key of ['startsAt', 'endsAt']) {
          if (typeof rule[key] !== 'string') return 'unknown';
          if (rule[key] !== '' && !Number.isFinite(Date.parse(rule[key]))) return 'unknown';
        }
        if (rule.startsAt && now < Date.parse(rule.startsAt)) return 'inactive';
        if (rule.endsAt && now >= Date.parse(rule.endsAt)) return 'inactive';
        if (/受注(?:生産|制作|製作)|made[\s-]*to[\s-]*order/i.test(rule.buttonName || '')) return 'made_to_order';
        if (/予約|pre[\s-]*order/i.test(rule.buttonName || '')) return 'pre_order';
        // The same app can also manage VIP sales or other non-reservation offers.
        return 'unknown';
      }

      static stockState(variant, entry, now) {
        if (!variant || typeof variant.available !== 'boolean') return '';
        if (!variant.available) return 'sold_out';
        const matches = entry && String(entry.id) === variant.id && entry.available === variant.available;
        const reservation = SSStockLabels.reservationState(matches ? entry : null, now);
        if (reservation === 'made_to_order' || reservation === 'pre_order') return reservation;
        // Untracked stock and unconfirmed backorders must not claim physical stock.
        if (variant.tracked !== true || !Number.isFinite(variant.quantity)) return '';
        if (variant.quantity > 0) {
          // An unsupported rule may reserve even stock-positive items.
          if (entry && entry.preOrderRule && reservation === 'unknown') return '';
          return 'in_stock';
        }
        if (variant.policy === 'deny') return 'sold_out';
        return '';
      }

      static matchingVariant(variants, selected, position, value) {
        return variants.find(variant => variant.options.every((option, index) =>
          option === (index === position ? value : selected[index])));
      }

      connectedCallback() {
        this.start = () => this.initialize();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.start, { once: true });
        } else {
          this.start();
        }
      }

      initialize() {
        if (!this.isConnected || this.initialized) return;
        this.form = this.closest('form');
        this.productForm = this.closest('product-form');
        try {
          this.data = JSON.parse(this.querySelector('[data-ss-stock-data]').textContent);
        } catch (_) { return; }
        if (!this.form || !Array.isArray(this.data.variants)) return;
        this.initialized = true;
        this.update = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.renderLabels());
        };
        this.form.addEventListener('change', this.update);
        this.productForm?.addEventListener('theme:variant:change', this.update);
        window.addEventListener('pageshow', this.update);
        this.timer = setInterval(this.update, 60000);
        this.renderLabels();
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        this.form?.removeEventListener('change', this.update);
        this.productForm?.removeEventListener('theme:variant:change', this.update);
        window.removeEventListener('pageshow', this.update);
        clearInterval(this.timer);
        cancelAnimationFrame(this.frame);
        this.initialized = false;
      }

      readReservationData() {
        // No request, API call, cart change, or app-private function call.
        const json = document.getElementById('ruffruff-pre-order-product-json');
        try {
          const data = JSON.parse(json?.textContent || 'null');
          return data && String(data.id) === this.data.productId ? data.variants : null;
        } catch (_) { return null; }
      }

      setLabel(target, state, kind) {
        let label = target.querySelector(':scope > .ss-variant-stock');
        if (!label) {
          label = document.createElement('span');
          label.className = 'ss-variant-stock';
          target.append(label);
        }
        label.textContent = this.data.labels[state] || '';
        label.hidden = !label.textContent;
        label.dataset.stockState = state;
        if (kind === 'radio') target.classList.toggle('ss-stock-option', !label.hidden);
        if (kind === 'swatch') target.classList.toggle('ss-stock-swatch', !label.hidden);
        return label;
      }

      renderLabels() {
        const entries = this.readReservationData();
        const now = Date.now();
        const stateFor = variant => SSStockLabels.stockState(
          variant, variant && entries?.[variant.id], now);
        const wrappers = Array.from(this.form.querySelectorAll('[data-option-position]'));
        const selected = [];
        wrappers.forEach(wrapper => {
          const index = Number(wrapper.dataset.optionPosition) - 1;
          const input = wrapper.querySelector('input[type="radio"]:checked, input[data-popout-input]');
          selected[index] = input?.value;
        });
        wrappers.forEach(wrapper => {
          const index = Number(wrapper.dataset.optionPosition) - 1;
          wrapper.querySelectorAll('input[type="radio"]').forEach(input => {
            const label = Array.from(wrapper.querySelectorAll('label')).find(item => item.htmlFor === input.id);
            if (!label) return;
            const variant = SSStockLabels.matchingVariant(this.data.variants, selected, index, input.value);
            const swatch = input.closest('radio-swatch');
            const status = this.setLabel(swatch || label, stateFor(variant), swatch ? 'swatch' : 'radio');
            if (swatch) {
              status.id = `${encodeURIComponent(this.form.id)}-${encodeURIComponent(input.id)}-ss-stock`;
              const descriptions = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
              descriptions.add(status.id);
              input.setAttribute('aria-describedby', Array.from(descriptions).join(' '));
            }
          });
          wrapper.querySelectorAll('[data-popout-option]').forEach(option => {
            const variant = SSStockLabels.matchingVariant(this.data.variants, selected, index, option.dataset.value);
            this.setLabel(option, stateFor(variant), 'dropdown');
          });
          wrapper.querySelectorAll('.radio__inputs--equal').forEach(group => {
            group.classList.toggle('ss-stock-equal', !!group.querySelector('.ss-stock-option'));
          });
        });
        const single = this.querySelector('[data-ss-stock-single]');
        const currentId = this.form.querySelector('input[name="id"]')?.value;
        const current = this.data.variants.find(variant => variant.id === currentId);
        const state = this.data.defaultVariant ? stateFor(current) : '';
        single.textContent = this.data.labels[state] || '';
        single.hidden = !single.textContent;
        single.dataset.stockState = state;
      }
    }
    customElements.define('ss-stock-labels', SSStockLabels);
  })();
  } catch(e) { console.error(e); }
})();

})();
